import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import History from './pages/History';
import MapLocation from './pages/Map';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/map/:type" element={<MapLocation />} />
        <Route path="/map" element={<MapLocation />} />
        <Route path="/historie" element={<History />} />
      </Routes>
    </Router>
  );
}

export default App;